import React from 'react';
import BuilderComponent from '../../../components/BuilderComponent';
import { Wrapper } from '../../components';
import { trackFbEvents } from '../../../functions/fbPixel';

export default function LandingPage() {
  return (
    <Wrapper>
      <BuilderComponent
        entries={{
          de: '13bf419a719f408d876ec321a21eebc7',
          en: 'cf2e8b9d21134d86b89f373b74ead7af',
          sv: 'aec6c2e0077441db87deecb2ba4d1295',
        }}
        context={{
          trackStartToCode: () => trackFbEvents('StartToCode'),
        }}
      />
    </Wrapper>
  );
}
